<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>Adicionar materias para {{dados_gradecurricular.nome_curso}}</h1>
        </div>
       
     
  </div>

  <div>
          <form @submit.prevent="addNovo()">
              <div class="row">
                <div class="flex md4 sm12 xs12">
                  
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="oferta_dis_grade.disciplina"
                      textBy="nome"
                      :options="getallDisciplinas"
                      placeholder="Disciplina"
                    />
                
                  </div>

                  <div class="flex md3 sm12 xs12">
                  
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="oferta_dis_grade.tipo_disciplina"
                      textBy="nome"
                      :options="getallTipodiciplinas"
                      placeholder="Tipo Disciplina"
                    />
                    
                
                  </div>
                      <div class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="oferta_dis_grade.carga_horaria"
                          placeholder="Carga horaria "
                        />
                      </div>


                      <div class="flex md2 sm12 xs12 text-center">
                          <va-button type="submit" class="text-right"   color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                      </div>
                
                </div>
              
          </form>

  </div>
 
    <va-data-table
          :fields="fields"
          :data="getDados"
          hoverable
          no-pagination
          >
          
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
                <va-button flat small color="primary" @click="abrirGradeCurricular(props.rowData)" class="ma-0">
                  {{ $t('tables.entrar') }}
                </va-button>

                <va-button flat small color="danger" @click="remove(props.rowData)" class="ma-0">
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
              
        </va-data-table>

   

</div>

      
</template>

<script>

export default {
  name: 'setgradecurricular',
  

  data () {
      return {
       
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
      
        dados_gradecurricular:'',

        oferta_dis_grade: {

          tipo_disciplina:'',
          disciplina:'',
          carga_horaria:'',
          grade_id: this.$store.state.gradecurricular.dados_gradecurricular.id

        }
     
      }
    },
      created (){

        this.buscar()
        this.buscarDisciplinas()
        this.buscarTipoDisciplina()
        this.buscarOfertaGradeDisciplina()
      },

  computed: {

    getDados(){
      return this.$store.state.gradecurricular.lista_grade_oferta_disciplina
    },

    getallTipodiciplinas(){
      return this.$store.state.tipo_disciplinas.tipo_disciplinas
    },
    getallDisciplinas(){
      return this.$store.state.disciplinas.disciplinas   
    },
    buscarTeste () {
    return this.$store.state.gradecurricular.dados_gradecurricular.id
    },
  
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_disciplina',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'nome_tipo_disciplina',
          title: this.$t('tables.headings.email'),
        },
         {
          name: 'carga_horaria',
          title: this.$t('tables.headings.email'),
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  },

  methods: {

    buscarDisciplinas (){
      this.$store.dispatch('allDisciplinas',this.disciplinas)
    },
    buscarTipoDisciplina (){
      this.$store.dispatch('allTipo_disciplinas',this.disciplinas)
    },
    buscarOfertaGradeDisciplina (){
      this.$store.dispatch('allOfertaGradeCurricular',this.dados_gradecurricular)
    },
    buscar () {
      this.dados_gradecurricular = this.$store.state.gradecurricular.dados_gradecurricular
    },
    
    addNovo () {
      console.log(this.oferta_dis_grade)
      this.$store.dispatch('addOfertaGradeDisciplina',this.oferta_dis_grade)

        this.oferta_dis_grade = {
          tipo_disciplina:'',
          disciplina:'',
          carga_horaria:'',
          grade_id: this.dados_gradecurricular.id
        }

        this.buscarOfertaGradeDisciplina()
       // this.buscar()
    }

  },
}
</script>

<style lang="scss">

</style>
